
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Définition de l'Outbound : l’agence ALEO vous l’explique",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez comment l’Outbound Marketing, associé à une approche ciblée et créative, peut booster la notoriété de votre marque et attirer rapidement de nouveaux clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Définition de l'Outbound Marketing : l’agence ALEO vous l’explique",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Découvrez comment l’Outbound Marketing, associé à une approche ciblée et créative, peut booster la notoriété de votre marque et attirer rapidement de nouveaux clients.",
        },
      ],
    };
  },
};
